import React from "react";
import image from "../assets/sam_header.png";

const Loader = () => {
  return (
    <div className="main" id="loader-container">
      <div className="container">
        <img src={image} alt="" />
        <div className="loading-indicator"></div>
        <h4 className="subtitle">Aadinath Exports</h4>
      </div>
    </div>
  );
};

export default Loader;
